import { WarrantyLogModel } from '../../../model/types';
import styles from './styles.module.scss';
import { InlineSvg } from 'components/svg';
import { useEditModalStore } from 'pages/warranty-logs/model/use-edit-modal.store';
import { FC } from 'react';
import { Button } from 'shared/ui/controls';

export const ActionCell: FC<{ data: WarrantyLogModel }> = ({ data }) => {
  const { showModal } = useEditModalStore();

  return (
    <Button
      text="Edit"
      icon={<InlineSvg path="/media/icons/custom/pencil.svg" />}
      variant="secondary"
      size="sm"
      additionalClass={styles.editBtn}
      onClick={() => data.id && showModal(data.id)}
    />
  );
};
